import { ADD_TEAM, ADD_TEAM_FAIL, ADD_TEAM_SUCCESS } from './actionTypes';

export const addTeam = team => ({
    type: ADD_TEAM,
    payload: team
});

export const addTeamSuccess = team => ({
    type: ADD_TEAM_SUCCESS,
    payload: team
});

export const addTeamFail = error => ({
    type: ADD_TEAM_FAIL,
    payload: error
});
